import { Resource } from "i18next"

export type TranslationKey =
  | "Common_Format_Date"
  | "Common_Format_Time"
  | "Common_Form_Error_MandatoryField"
  | "Common_Error_Offline"
  | "Common_Yes"
  | "AuthSignOutModal_Title"
  | "AuthSignOutModal_Description"
  | "AuthSignInView_Title"
  | "AuthSignInView_Label"
  | "AuthSignInView_Email"
  | "AuthSignInView_Password"
  | "AuthSignInView_Login"
  | "AuthSignInView_ForgotPassword"
  | "AuthSignInView_Error_LoggedOut"
  | "ErrorView_Title"
  | "VersionProvider_Reload_Message"
  | "VersionProvider_Reload_Action"
  | "MessageForm_Label_Text"
  | "ChannelsView_ChannelType_Direct"
  | "ChannelsView_ChannelType_Group"
  | "ChannelsView_ChatStatus_Online"
  | "ChannelsView_ChatStatus_Offline"
  | "ChannelsView_ChatStatus_Idle"
  | "ChannelsView_Error_NoChannels"
  | "OrganizationsView_Title"
  | "OrganizationsView_Error_NoOrganizations"
  | "OrganizationSignInView_Title"
  | "OrganizationSignInView_Message"
  | "OrganizationSignInView_Cta"
  | "OrganizationSuggestionCtaView_Message"
  | "OrganizationSuggestionCtaView_Cta"
  | "OrganizationSuggestionModal_Title"
  | "OrganizationSuggestionForm_Title"
  | "OrganizationSuggestionForm_Label_OrganizationName"
  | "OrganizationSuggestionForm_Label_OrganizationCity"
  | "OrganizationSuggestionForm_Button_Submit"
  | "OrganizationSuggestionForm_Snackbar_Success"
  | "OrganizationsAddableModal_Title"
  | "OrganizationsAddableView_Error_NoOrganizations"
  | "OrganizationsAddableView_Label_Search"
  | "OrganizationsInfo_Title"
  | "OrganizationsInfo_Body";

export const translationResources: Resource = {
  en: {
    translation: {
      "Common_Format_Date": "D/M/YYYY",
      "Common_Format_Time": "HH:mm",
      "Common_Form_Error_MandatoryField": "{{field}} is a mandatory field",
      "Common_Error_Offline": "No Internet connection available. Please check your internet and reload this page.",
      "Common_Yes": "Yes",
      "AuthSignOutModal_Title": "Logout",
      "AuthSignOutModal_Description": "Are you sure you want to logout?",
      "AuthSignInView_Title": "Welcome to the Craftnote Partner Chat.",
      "AuthSignInView_Label": "You can log in here with your Craftnote email and password. Have fun testing.",
      "AuthSignInView_Email": "Email",
      "AuthSignInView_Password": "Password",
      "AuthSignInView_Login": "Login",
      "AuthSignInView_ForgotPassword": "Forgot password",
      "AuthSignInView_Error_LoggedOut": "You are not logged in anymore. Please reload the page!",
      "ErrorView_Title": "Oh no, an error occurred:",
      "VersionProvider_Reload_Message": "There is a new version of the external chat. The website will reload in {{seconds}} seconds.",
      "VersionProvider_Reload_Action": "Reload now",
      "MessageForm_Label_Text": "Message",
      "ChannelsView_ChannelType_Direct": "Direct chat",
      "ChannelsView_ChannelType_Group": "Group chat",
      "ChannelsView_ChatStatus_Online": "Online",
      "ChannelsView_ChatStatus_Offline": "Offline",
      "ChannelsView_ChatStatus_Idle": "Idle",
      "ChannelsView_Error_NoChannels": "This organization has no chat rooms.",
      "OrganizationsView_Title": "My partners",
      "OrganizationsView_Error_NoOrganizations": "You currently have no partners yet.",
      "OrganizationSignInView_Title": "Better communication!",
      "OrganizationSignInView_Message": "Click here and we will connect you directly to your representative",
      "OrganizationSignInView_Cta": "Get started",
      "OrganizationSuggestionCtaView_Message": "If you already have existing partner, take one minute to let us know so we can arrange a communication channel for you.",
      "OrganizationSuggestionCtaView_Cta": "Partner request",
      "OrganizationSuggestionModal_Title": "Partner request",
      "OrganizationSuggestionForm_Title": "Which partner you like to work with via Craftnote?",
      "OrganizationSuggestionForm_Label_OrganizationName": "Name of partner",
      "OrganizationSuggestionForm_Label_OrganizationCity": "City",
      "OrganizationSuggestionForm_Button_Submit": "Submit",
      "OrganizationSuggestionForm_Snackbar_Success": "Thank you. We will contact your partner.",
      "OrganizationsAddableModal_Title": "Available partners",
      "OrganizationsAddableView_Error_NoOrganizations": "There are no more organizations to add.",
      "OrganizationsAddableView_Label_Search": "Search",
      "OrganizationsInfo_Title": "Did you know?",
      "OrganizationsInfo_Body": "Use this button to add your first available partners now!",
    },
  },
  de: {
    translation: {
      "Common_Format_Date": "DD.MM.YYYY",
      "Common_Format_Time": "HH:mm",
      "Common_Form_Error_MandatoryField": "{{field}} ist ein Pflichtfeld",
      "Common_Error_Offline": "Kein Internet verfügbar. Bitte überprüfe Deine Internetverbindung und lade die Seite neu!",
      "Common_Yes": "Ja",
      "AuthSignOutModal_Title": "Abmelden",
      "AuthSignOutModal_Description": "Möchtest Du Dich wirklich abmelden?",
      "AuthSignInView_Title": "Willkommen beim Craftnote Partner Chat",
      "AuthSignInView_Label": "Logge Dich hier, wie gewohnt, mit Deiner Craftnote E-Mail und Passwort ein!",
      "AuthSignInView_Email": "E-Mail",
      "AuthSignInView_Password": "Passwort",
      "AuthSignInView_Login": "Anmelden",
      "AuthSignInView_ForgotPassword": "Passwort vergessen",
      "AuthSignInView_Error_LoggedOut": "Du bist nicht mehr angemeldet. Bitte lade die Webseite neu!",
      "ErrorView_Title": "Oh nein, ein Fehler ist aufgetreten:",
      "VersionProvider_Reload_Message": "Es gibt eine neue Version vom Partner Chat. Die Webseite lädt in {{seconds}} Sekunden neu.",
      "VersionProvider_Reload_Action": "Jetzt neu laden",
      "MessageForm_Label_Text": "Nachricht",
      "ChannelsView_ChannelType_Direct": "Direkter Chat",
      "ChannelsView_ChannelType_Group": "Gruppenchat",
      "ChannelsView_ChatStatus_Online": "Aktiv",
      "ChannelsView_ChatStatus_Offline": "Inaktiv",
      "ChannelsView_ChatStatus_Idle": "In Kürze verfügbar",
      "ChannelsView_Error_NoChannels": "Diese Organisation hat noch keine Chaträume.",
      "OrganizationsView_Title": "Meine Partner",
      "OrganizationsView_Error_NoOrganizations": "Du hast noch keine Partner!",
      "OrganizationSignInView_Title": "Bessere Kommunikation!",
      "OrganizationSignInView_Message": "Klicke hier und wir verbinden Dich direkt mit Deinem persönlichen Ansprechpartner",
      "OrganizationSignInView_Cta": "Jetzt loslegen",
      "OrganizationSuggestionCtaView_Message": "Du siehst Deinen Partner hier noch nicht?",
      "OrganizationSuggestionCtaView_Cta": "Neuen Händler anfragen",
      "OrganizationSuggestionModal_Title": "Neuen Partner anfragen",
      "OrganizationSuggestionForm_Title": "Mit welchem Partner möchtest Du via Craftnote kommunizieren?",
      "OrganizationSuggestionForm_Label_OrganizationName": "Name des Partners",
      "OrganizationSuggestionForm_Label_OrganizationCity": "Ort",
      "OrganizationSuggestionForm_Button_Submit": "Abschicken",
      "OrganizationSuggestionForm_Snackbar_Success": "Vielen Dank. Wir kontaktieren Deinen Partner.",
      "OrganizationsAddableModal_Title": "Verfügbare Partner",
      "OrganizationsAddableView_Error_NoOrganizations": "Es gibt keine weiteren Partner die Du hinzufügen kannst.",
      "OrganizationsAddableView_Label_Search": "Suche",
      "OrganizationsInfo_Title": "Wusstest Du?",
      "OrganizationsInfo_Body": "Klicke hier auf das Plus um Deinen ersten Partner hinzuzufügen!",
    },
  },
};
